// src/services/adminSeo.api.js
import { adminApiRequest } from "./adminApi";

export const getSeoByPage = (pageKey, entityId = null) => {
  const qs = entityId ? `?entity=${encodeURIComponent(entityId)}` : "";
  return adminApiRequest(`/admin/seo/${pageKey}${qs}`);
};

export const saveSeoByPage = (pageKey, entityId = null, data) => {
  const qs = entityId ? `?entity=${encodeURIComponent(entityId)}` : "";
  return adminApiRequest(`/admin/seo/${pageKey}${qs}`, {
    method: "POST",
    body: JSON.stringify(data),
  });
};
